import callFunctionOnce from "../../utils/CallFunctionOnce"
import { initEnquiry } from "../../utils/Enquiries"

export const initOfferEnquiries = () => {
  document.querySelectorAll(".js-offer-enquiry").forEach(initEnquiry)
}

export const initFeaturedOfferEnquiries = callFunctionOnce(() => {
  document.querySelectorAll(".js-featured-offer-enquiry").forEach(initEnquiry)
})




// WEBPACK FOOTER //
// ./components/enquiries/InitOfferEnquiries.js